import EventEmitter from 'events';

import { toast } from '@ethsign/ui';
import { AuthType } from '@particle-network/auth-core';
import { AuthCoreContextProvider, EVMProvider, useAuthCore, useConnect, useEthereum } from '@particle-network/authkit';
import { mainnet } from '@particle-network/authkit/chains';
import { ReactNode, useEffect } from 'react';

import { ENVS } from '@/constants';
import { WalletBase } from '@/utils/wallet/WalletBase';
import { ISignResult } from '@/utils/wallet/types';

const particleStore = {
  provider: null as EVMProvider | null,
  userInfo: null as any,
  address: null,
  isConnected: false,
  authType: null,
  eventBus: new EventEmitter()
};

export class ParticleWallet extends WalletBase {
  getStore() {
    return particleStore;
  }
  init(): void {
    this.chainId = 1;
    this.provider = particleStore.provider;
  }

  async disconnect(): Promise<void> {
    this.isConnected = false;
    particleStore.userInfo = null;
    await this.provider?.disconnect();
  }
  async connect(authType: 'google' | 'twitter'): Promise<boolean> {
    if (!this.provider) return false;
    const userInfo = particleStore.userInfo;

    console.log(userInfo, authType);
    if (!userInfo || userInfo?.thirdparty_user_info?.provider !== authType) {
      await this.provider.disconnect();
      await (this.provider as EVMProvider).connect({
        socialType: authType,
        chain: mainnet
        // authorization: {
        //   uniq: false
        // }
      });
    }

    const account = this.provider.selectedAddress;
    this.address = account;
    this.isConnected = true;
    this.authType = authType;
    return true;
  }

  async sign(message: string): Promise<ISignResult> {
    const msg = `0x${Buffer.from(message).toString('hex')}`;
    const signature = await this.provider.signMessage(msg);

    return {
      message: message,
      signature
    };
  }

  static setCallback(fn: (data: any) => void) {
    if (particleStore.eventBus.listeners('particle-connected')?.length) return;
    particleStore.eventBus.once('particle-connected', function (data) {
      // 没有setTimeout会弹出空白窗口
      setTimeout(() => {
        fn(data);
      }, 1000);
    });
  }
}

export const ParticleConnector = () => {
  const { setSocialConnectCallback } = useConnect();
  const { provider } = useEthereum();
  const { userInfo } = useAuthCore();
  particleStore.provider = provider;

  useEffect(() => {
    if (userInfo) {
      particleStore.userInfo = userInfo;
    }
  }, [userInfo]);

  useEffect(() => {
    setSocialConnectCallback({
      onError: (error: any) => {
        console.log('SocialConnectCallback onError', error);
        toast({
          variant: 'error',
          title: 'Error',
          description: error.message
        });
      },
      onSuccess: (info: any) => {
        console.log('SocialConnectCallback onSuccess', info);
        particleStore.eventBus.emit('particle-connected', info);
      }
    });
    return () => {
      setSocialConnectCallback(undefined);
    };
  }, []);

  return null;
};

export const ParticleProvider = ({ children }: { children: ReactNode }) => {
  return (
    <AuthCoreContextProvider
      options={{
        projectId: ENVS.VITE_PARTICLE_PROJECT_ID!,
        clientKey: ENVS.VITE_PARTICLE_CLIENT_KEY!,
        appId: ENVS.VITE_PARTICLE_APP_ID!,
        chains: [mainnet], //optional: current chain name, default Ethereum.
        authTypes: [AuthType.google, AuthType.twitter]
      }}
    >
      {children}
      <ParticleConnector />
    </AuthCoreContextProvider>
  );
};
